import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg viewBox="0 0 129.467 113.309" ref={svgRef} {...props}>
    <defs>
      <style>
        {
          '.prefix__cls-3{fill:#0062a1}.prefix__cls-4{fill:none;stroke:#a4ce4b;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.551px}.prefix__cls-5{fill:#f2f2f2}.prefix__cls-8{fill:#f2f2f3}'
        }
      </style>
    </defs>
    <g
      id="prefix__Group_1632"
      data-name="Group 1632"
      transform="translate(-655 -558.225)"
    >
      <g id="calendar" data-name="Group 1631">
        <path
          id="prefix__Rectangle_452"
          data-name="Rectangle 452"
          transform="translate(655 559.8)"
          fill="#d9d9d6"
          d="M0 0h99.2v99.2H0z"
        />
        <path
          id="prefix__Rectangle_453"
          data-name="Rectangle 453"
          transform="translate(655 559.8)"
          fill="#218ece"
          d="M0 0h99.2v24.8H0z"
        />
        <path
          id="prefix__Path_319"
          data-name="Path 319"
          className="prefix__cls-3"
          d="M16.167 9.533a6.035 6.035 0 0 1-6.133 6.133A6.035 6.035 0 0 1 3.9 9.533 6.035 6.035 0 0 1 10.033 3.4a6.2 6.2 0 0 1 6.133 6.133"
          transform="translate(661.5 562.534)"
        />
        <path
          id="prefix__Line_38"
          data-name="Line 38"
          className="prefix__cls-4"
          transform="translate(671.533 559)"
          d="M0 13.067V0"
        />
        <path
          id="prefix__Path_320"
          data-name="Path 320"
          className="prefix__cls-3"
          d="M28.567 9.533a6.133 6.133 0 1 1-12.267 0A6.035 6.035 0 0 1 22.433 3.4a6.2 6.2 0 0 1 6.133 6.133"
          transform="translate(682.167 562.534)"
        />
        <path
          id="prefix__Line_39"
          data-name="Line 39"
          className="prefix__cls-4"
          transform="translate(704.6 559)"
          d="M0 13.067V0"
        />
        <path
          id="prefix__Path_321"
          data-name="Path 321"
          className="prefix__cls-3"
          d="M41.067 9.533a6.133 6.133 0 1 1-12.267 0A6.035 6.035 0 0 1 34.933 3.4a6.39 6.39 0 0 1 6.133 6.133"
          transform="translate(703 562.534)"
        />
        <path
          id="prefix__Line_40"
          data-name="Line 40"
          className="prefix__cls-4"
          transform="translate(737.667 559)"
          d="M0 13.067V0"
        />
        <path
          id="prefix__Path_322"
          data-name="Path 322"
          className="prefix__cls-5"
          d="M14.3 25.233H6.033A2.1 2.1 0 0 1 3.9 23.1v-8.267A2.1 2.1 0 0 1 6.033 12.7H14.3a2.1 2.1 0 0 1 2.133 2.133V23.1c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(661.5 578.034)"
        />
        <path
          id="prefix__Path_323"
          data-name="Path 323"
          className="prefix__cls-5"
          d="M20.5 25.233h-8.267A2.1 2.1 0 0 1 10.1 23.1v-8.267a2.1 2.1 0 0 1 2.133-2.133H20.5a2.1 2.1 0 0 1 2.133 2.133V23.1c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(671.833 578.034)"
        />
        <path
          id="prefix__Path_324"
          data-name="Path 324"
          className="prefix__cls-5"
          d="M26.7 25.233h-8.267A2.1 2.1 0 0 1 16.3 23.1v-8.267a2.1 2.1 0 0 1 2.133-2.133H26.7a2.1 2.1 0 0 1 2.133 2.133V23.1c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(682.167 578.034)"
        />
        <path
          id="prefix__Path_325"
          data-name="Path 325"
          className="prefix__cls-5"
          d="M32.9 25.233h-8.267A2.1 2.1 0 0 1 22.5 23.1v-8.267a2.1 2.1 0 0 1 2.133-2.133H32.9a2.1 2.1 0 0 1 2.133 2.133V23.1c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(692.5 578.034)"
        />
        <path
          id="prefix__Path_326"
          data-name="Path 326"
          className="prefix__cls-5"
          d="M39.1 25.233h-8.267A2.1 2.1 0 0 1 28.7 23.1v-8.267a2.1 2.1 0 0 1 2.133-2.133H39.1a2.1 2.1 0 0 1 2.133 2.133V23.1a2.294 2.294 0 0 1-2.133 2.133"
          transform="translate(702.833 578.034)"
        />
        <path
          id="prefix__Path_327"
          data-name="Path 327"
          className="prefix__cls-5"
          d="M14.3 31.433H6.033A2.1 2.1 0 0 1 3.9 29.3v-8.267A2.1 2.1 0 0 1 6.033 18.9H14.3a2.1 2.1 0 0 1 2.133 2.133V29.3c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(661.5 588.367)"
        />
        <path
          id="prefix__Path_328"
          data-name="Path 328"
          className="prefix__cls-5"
          d="M20.5 31.433h-8.267A2.1 2.1 0 0 1 10.1 29.3v-8.267a2.1 2.1 0 0 1 2.133-2.133H20.5a2.1 2.1 0 0 1 2.133 2.133V29.3c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(671.833 588.367)"
        />
        <path
          id="prefix__Path_329"
          data-name="Path 329"
          className="prefix__cls-5"
          d="M26.7 31.433h-8.267A2.1 2.1 0 0 1 16.3 29.3v-8.267a2.1 2.1 0 0 1 2.133-2.133H26.7a2.1 2.1 0 0 1 2.133 2.133V29.3c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(682.167 588.367)"
        />
        <path
          id="prefix__Path_330"
          data-name="Path 330"
          className="prefix__cls-5"
          d="M32.9 31.433h-8.267A2.1 2.1 0 0 1 22.5 29.3v-8.267a2.1 2.1 0 0 1 2.133-2.133H32.9a2.1 2.1 0 0 1 2.133 2.133V29.3c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(692.5 588.367)"
        />
        <path
          id="prefix__Path_331"
          data-name="Path 331"
          className="prefix__cls-5"
          d="M39.1 31.433h-8.267A2.1 2.1 0 0 1 28.7 29.3v-8.267a2.1 2.1 0 0 1 2.133-2.133H39.1a2.1 2.1 0 0 1 2.133 2.133V29.3a2.294 2.294 0 0 1-2.133 2.133"
          transform="translate(702.833 588.367)"
        />
        <path
          id="prefix__Path_332"
          data-name="Path 332"
          className="prefix__cls-5"
          d="M14.3 37.633H6.033A2.1 2.1 0 0 1 3.9 35.5v-8.267A2.1 2.1 0 0 1 6.033 25.1H14.3a2.1 2.1 0 0 1 2.133 2.133V35.5c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(661.5 598.7)"
        />
        <path
          id="prefix__Path_333"
          data-name="Path 333"
          className="prefix__cls-5"
          d="M20.5 37.633h-8.267A2.1 2.1 0 0 1 10.1 35.5v-8.267a2.1 2.1 0 0 1 2.133-2.133H20.5a2.1 2.1 0 0 1 2.133 2.133V35.5c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(671.833 598.7)"
        />
        <path
          id="prefix__Path_334"
          data-name="Path 334"
          className="prefix__cls-5"
          d="M26.7 37.633h-8.267A2.1 2.1 0 0 1 16.3 35.5v-8.267a2.1 2.1 0 0 1 2.133-2.133H26.7a2.1 2.1 0 0 1 2.133 2.133V35.5c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(682.166 598.7)"
        />
        <path
          id="prefix__Path_335"
          data-name="Path 335"
          className="prefix__cls-5"
          d="M32.9 37.633h-8.267A2.1 2.1 0 0 1 22.5 35.5v-8.267a2.1 2.1 0 0 1 2.133-2.133H32.9a2.1 2.1 0 0 1 2.133 2.133V35.5c-.267 1.067-1.067 2.133-2.133 2.133"
          transform="translate(692.499 598.7)"
        />
        <path
          id="prefix__Path_336"
          data-name="Path 336"
          className="prefix__cls-5"
          d="M39.1 37.633h-8.267A2.1 2.1 0 0 1 28.7 35.5v-8.267a2.1 2.1 0 0 1 2.133-2.133H39.1a2.1 2.1 0 0 1 2.133 2.133V35.5a2.294 2.294 0 0 1-2.133 2.133"
          transform="translate(702.832 598.7)"
        />
        <path
          id="prefix__Path_337"
          data-name="Path 337"
          className="prefix__cls-5"
          d="M14.3 43.833H6.033A2.1 2.1 0 0 1 3.9 41.7v-8.267A2.1 2.1 0 0 1 6.033 31.3H14.3a2.1 2.1 0 0 1 2.133 2.133V41.7c-.267 1.333-1.067 2.133-2.133 2.133"
          transform="translate(661.5 609.034)"
        />
        <path
          id="prefix__Path_338"
          data-name="Path 338"
          className="prefix__cls-5"
          d="M20.5 43.833h-8.267A2.1 2.1 0 0 1 10.1 41.7v-8.267a2.1 2.1 0 0 1 2.133-2.133H20.5a2.1 2.1 0 0 1 2.133 2.133V41.7c-.267 1.333-1.067 2.133-2.133 2.133"
          transform="translate(671.833 609.034)"
        />
        <path
          id="prefix__Path_339"
          data-name="Path 339"
          className="prefix__cls-5"
          d="M26.7 43.833h-8.267A2.1 2.1 0 0 1 16.3 41.7v-8.267a2.1 2.1 0 0 1 2.133-2.133H26.7a2.1 2.1 0 0 1 2.133 2.133V41.7c-.267 1.333-1.067 2.133-2.133 2.133"
          transform="translate(682.166 609.034)"
        />
        <path
          id="prefix__Path_340"
          data-name="Path 340"
          className="prefix__cls-5"
          d="M32.9 43.833h-8.267A2.1 2.1 0 0 1 22.5 41.7v-8.267a2.1 2.1 0 0 1 2.133-2.133H32.9a2.1 2.1 0 0 1 2.133 2.133V41.7c-.267 1.333-1.067 2.133-2.133 2.133"
          transform="translate(692.499 609.034)"
        />
        <path
          id="prefix__Path_341"
          data-name="Path 341"
          className="prefix__cls-5"
          d="M39.1 43.833h-8.267A2.1 2.1 0 0 1 28.7 41.7v-8.267a2.1 2.1 0 0 1 2.133-2.133H39.1a2.1 2.1 0 0 1 2.133 2.133V41.7a2.1 2.1 0 0 1-2.133 2.133"
          transform="translate(702.832 609.034)"
        />
      </g>
      <g id="money" data-name="Group 1630">
        <path
          id="prefix__Rectangle_454"
          data-name="Rectangle 454"
          transform="translate(697 623)"
          fill="#a4ce4d"
          d="M0 0h87.467v48.533H0z"
        />
        <g
          id="prefix__Group_1629"
          data-name="Group 1629"
          transform="translate(-.133 -44.467)"
        >
          <path
            id="prefix__Rectangle_455"
            data-name="Rectangle 455"
            className="prefix__cls-8"
            transform="translate(697.133 667.467)"
            d="M0 0h46.133v4.8H0z"
          />
          <path
            id="prefix__Rectangle_456"
            data-name="Rectangle 456"
            className="prefix__cls-8"
            transform="translate(697.133 711.2)"
            d="M0 0h46.133v4.8H0z"
          />
          <path
            id="prefix__Rectangle_457"
            data-name="Rectangle 457"
            className="prefix__cls-8"
            transform="translate(697.133 667.467)"
            d="M0 0h4.8v48.533H0z"
          />
          <path
            id="prefix__Path_342"
            data-name="Path 342"
            className="prefix__cls-8"
            d="M30.3 31.8a7.2 7.2 0 1 1-7.2-7.2 7.345 7.345 0 0 1 7.2 7.2"
            transform="translate(681.5 642.867)"
          />
          <path
            id="prefix__Path_343"
            data-name="Path 343"
            className="prefix__cls-8"
            d="M30.3 44.61a7.2 7.2 0 1 1-7.2-7.2 7 7 0 0 1 7.2 7.2"
            transform="translate(681.5 664.19)"
          />
          <path
            id="prefix__Path_344"
            data-name="Path 344"
            className="prefix__cls-8"
            d="M52.6 42.867c0 8-5.333 14.667-12 14.667s-12-6.4-12-14.667c0-8 5.333-14.667 12-14.667s12 6.4 12 14.667"
            transform="translate(702.667 648.867)"
          />
          <path
            id="prefix__Rectangle_458"
            data-name="Rectangle 458"
            className="prefix__cls-8"
            transform="translate(743.267 667.467)"
            d="M0 0h41.333v4.8H0z"
          />
          <path
            id="prefix__Rectangle_459"
            data-name="Rectangle 459"
            className="prefix__cls-8"
            transform="translate(743.267 711.2)"
            d="M0 0h41.333v4.8H0z"
          />
          <path
            id="prefix__Rectangle_460"
            data-name="Rectangle 460"
            className="prefix__cls-8"
            transform="translate(779.8 667.467)"
            d="M0 0h4.8v48.533H0z"
          />
          <path
            id="prefix__Path_345"
            data-name="Path 345"
            className="prefix__cls-8"
            d="M57.6 31.8a7.2 7.2 0 1 1-7.2-7.2 7.17 7.17 0 0 1 7.2 7.2"
            transform="translate(727 642.867)"
          />
          <path
            id="prefix__Path_346"
            data-name="Path 346"
            className="prefix__cls-8"
            d="M57.6 44.61a7.2 7.2 0 1 1-7.2-7.2c4-.267 7.2 2.933 7.2 7.2"
            transform="translate(727 664.19)"
          />
        </g>
      </g>
    </g>
  </svg>
)

const InsuranceBenefitsSVGNonTCA = React.forwardRef((props, ref) => (
  <SvgComponent svgRef={ref} {...props} />
))
export default InsuranceBenefitsSVGNonTCA
